var UIMessageModel = /** @class */ (function () {
    function UIMessageModel(source) {
        this.id = source.id;
        this.modifier = source.modifier;
        this.label = source.label;
        this.type = source.type;
        this.handler = source.handler;
    }
    return UIMessageModel;
}());
export { UIMessageModel };
//# sourceMappingURL=UIMessageModel.js.map